export const articles = [
  {
    id: "1",
    slug: "wanghong-dasai-2026-07-06",
    title: "网红每日大赛：反差女神翻车现场，网友直呼太离谱",
    excerpt: "今日网红大赛又出大瓜！号称清纯女神的某千万粉网红直播卸妆翻车，真实颜值引热议，评论区炸锅。",
    content: "今日网红大赛再次迎来高能时刻。拥有1200万粉丝、平时以清纯形象示人的知名网红「小鹿酱」在最新一场直播中应粉丝要求当场卸妆，结果让所有人大跌眼镜。\n\n直播开始时，小鹿酱一如既往地以精致妆容亮相，弹幕纷纷刷屏「女神好美」。然而当卸妆棉擦去厚重的粉底和眼妆后，真实面貌与平时判若两人，连直播间的工作人员都忍不住笑场。\n\n这一反差巨大的画面迅速被网友截图传播，话题#网红卸妆翻车#直接冲上微博热搜前三。有网友评论：「这反差也太大了吧，平时滤镜开得有多夸张？」也有人力挺：「敢于素颜出镜已经很勇敢了，不要对女生太苛刻。」\n\n小鹿酱随后在社交平台发文回应：「感谢大家的关注，每个人都有美的一面和真实的一面，我不后悔展示真实的自己。」这条回应获得了超过50万点赞。\n\n这场风波也从侧面反映出当前网红行业普遍存在的「滤镜焦虑」问题，多位业内人士呼吁直播平台加强美颜标识管理。",
    category: "wanghong-dasai",
    categoryName: "网红每日大赛",
    author: "51爆料编辑部",
    authorAvatar: "",
    publishDate: "2026-07-06",
    readTime: "5分钟",
    viewCount: 128000,
    tags: ["网红", "反差", "直播", "卸妆", "翻车"],
    imageSeq: "article-1-hero",
    image: "https://readdy.ai/api/search-image?query=Chinese%20internet%20celebrity%20livestreaming%20studio%20scene%20with%20dramatic%20makeup%20mirror%20and%20warm%20lighting%2C%20modern%20aesthetic%20with%20soft%20bokeh%20background%2C%20editorial%20style%2C%20warm%20crimson%20and%20gold%20tones%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20netflix%20documentary%20style&width=1600&height=900&seq=article-1-hero&orientation=landscape",
    relatedArticles: ["2", "3", "4"],
  },
  {
    id: "2",
    slug: "mingxing-bagua-zhang-2026-07-05",
    title: "独家爆料：某顶流男星深夜密会神秘女子，工作室紧急回应",
    excerpt: "据可靠消息，某顶流男星上周深夜被拍到与一名神秘女子同回公寓，工作室凌晨三点发布声明否认恋情。",
    content: "据51爆料独家获取的消息，上周五凌晨，某当红顶流男星被拍到与一位身着黑色连衣裙的神秘女子一同返回其位于北京朝阳区的私人公寓，直到第二天中午才独自离开。\n\n目击者称，两人在公寓楼下有说有笑，举止亲密，该女子还挽着男星的手臂进入电梯。照片已在多个社交平台流传，引发粉丝激烈讨论。\n\n事件发酵12小时后，该男星的工作室于凌晨三点紧急发布声明：「关于网络上流传的不实信息，我方已收集相关证据并交由律师处理。该男星目前单身，所谓恋情纯属造谣。」\n\n然而这份声明并未平息网友的质疑。有眼尖网友发现，声明中使用的措辞「目前单身」与此前「从未恋爱」的说法存在微妙差异，引发更多猜测。\n\n业内人士分析称，顶流男星的恋情传闻往往会对商业代言和综艺通告产生连锁反应。据统计，该男星目前有超过15个活跃品牌代言，若恋情坐实，部分品牌可能会重新考量合作条款。\n\n截至发稿，该男星本人尚未就此事作出任何回应。51爆料将持续跟踪报道。",
    category: "mingxing-bagua",
    categoryName: "明星八卦",
    author: "51爆料深度组",
    authorAvatar: "",
    publishDate: "2026-07-05",
    readTime: "8分钟",
    viewCount: 256000,
    tags: ["明星", "恋情", "爆料", "独家", "顶流"],
    imageSeq: "article-2-hero",
    image: "https://readdy.ai/api/search-image?query=luxury%20apartment%20building%20night%20scene%20with%20paparazzi%20vibe%2C%20dramatic%20lighting%20with%20red%20and%20gold%20neon%20tones%2C%20mysterious%20atmosphere%2C%20urban%20night%20aesthetic%2C%20cinematic%20noir%20style%2C%20dark%20shadows%20and%20warm%20highlights&width=1600&height=900&seq=article-2-hero&orientation=landscape",
    relatedArticles: ["1", "3", "5"],
  },
  {
    id: "3",
    slug: "heiliaozhuizong-zhibo-jiaoben-2026-07-04",
    title: "黑料追踪：知名带货主播被曝使用虚假剧本，直播间人气全靠演？",
    excerpt: "某头部带货主播被前员工曝光使用虚假剧本控制直播节奏，所谓的「真实砍价」竟是提前排练过的表演。",
    content: "51爆料接到前员工实名举报，某拥有3000万粉丝的头部带货主播长期使用精心编排的虚假剧本，所谓的「真实砍价」「突发事件」全部是提前策划的表演。\n\n举报人小李（化名）曾在某头部MCN机构担任直播运营，他向51爆料提供了多份内部聊天记录和剧本文件。根据这些材料显示，该主播的每一场直播都有详细的「剧情大纲」，包括「品牌方突然降价」「粉丝哭诉产品效果」「主播怒摔样品」等环节，全部按照剧本严格执行。\n\n「最夸张的一次是主播在直播间哭诉自己被品牌方欺骗，要求退款给粉丝。但事实上，那款产品的售价从始至终都是由团队设定的，所谓的'亏本销售'只是营销手段。」小李透露。\n\n该主播所属MCN机构回应称：「直播中的互动环节为节目效果设计，并非欺骗消费者。我们的产品质量和价格都具有市场竞争力。」\n\n但这一事件已经在消费者中引发轩然大波。多个消费者维权群开始组织集体投诉，要求相关部门介入调查直播带货行业的剧本化营销问题。\n\n北京市消费者协会表示将密切关注此事发展，并呼吁直播平台加强内容审核，保护消费者权益。",
    category: "heiliaozhuizong",
    categoryName: "黑料追踪",
    author: "51爆料调查组",
    authorAvatar: "",
    publishDate: "2026-07-04",
    readTime: "10分钟",
    viewCount: 389000,
    tags: ["黑料", "直播带货", "虚假剧本", "消费者权益", "曝光"],
    imageSeq: "article-3-hero",
    image: "https://readdy.ai/api/search-image?query=Chinese%20livestream%20shopping%20studio%20with%20bright%20ring%20lights%20and%20product%20display%2C%20dramatic%20red%20and%20gold%20atmosphere%2C%20behind%20the%20scenes%20documentary%20style%2C%20contrast%20between%20glamorous%20front%20and%20dark%20background%2C%20editorial%20cinematic%20lighting&width=1600&height=900&seq=article-3-hero&orientation=landscape",
    relatedArticles: ["1", "2", "6"],
  },
  {
    id: "4",
    slug: "chigua-fanchashipin-2026-07-03",
    title: "全网吃瓜：反差视频合集爆火，这些网红私下竟然是这样",
    excerpt: "近日一组「网红反差」视频合集在各大平台疯传，多位网红私下状态与镜头前判若两人，网友：世界欠她们一座奥斯卡。",
    content: "最近，一组名为「网红真实面貌大揭秘」的反差视频合集在全网引发轰动。该合集收录了超过20位知名网红的私下状态视频，与她们在社交平台上的精致形象形成鲜明对比。\n\n视频中可以看到，以「高冷名媛」人设走红的某网络红人，私下在餐馆大快朵颐的接地气画面；以「元气少女」著称的某跳舞主播，直播间隙疲惫抽烟的真实瞬间；以及以「贤妻良母」形象吸粉的某育儿博主，私下对助理发脾气的片段。\n\n这组视频在微博、抖音、B站等平台累计播放量已突破5亿次，相关话题阅读量超过20亿。\n\n知名社会评论员王教授指出：「网红反差现象本质上反映了互联网时代的身份表演问题。每个人都在社交媒体上进行着不同程度的自我包装，但当表演与真实的差距过大时，就会引发公众的反弹。」\n\n也有声音认为，公众对网红的要求过于苛刻：「谁不想展现自己最好的一面呢？网红也是普通人，允许她们有不完美的一面。」\n\n51爆料将持续关注此事进展，更多精彩内容请关注我们的每日大赛频道。",
    category: "chigua-shipin",
    categoryName: "吃瓜视频",
    author: "51爆料编辑部",
    authorAvatar: "",
    publishDate: "2026-07-03",
    readTime: "6分钟",
    viewCount: 520000,
    tags: ["吃瓜", "反差", "网红", "视频合集", "真实面貌"],
    imageSeq: "article-4-hero",
    image: "https://readdy.ai/api/search-image?query=split%20screen%20contrast%20between%20glamorous%20social%20media%20influencer%20and%20casual%20everyday%20life%2C%20dramatic%20red%20and%20warm%20gold%20lighting%2C%20mirror%20reflection%20concept%2C%20editorial%20photography%20style%2C%20high%20contrast%20between%20perfection%20and%20reality&width=1600&height=900&seq=article-4-hero&orientation=landscape",
    relatedArticles: ["1", "5", "6"],
  },
  {
    id: "5",
    slug: "mingxing-gongguan-weiji-2026-07-02",
    title: "明星公关危机：某女星慈善风波持续发酵，多个品牌暂停合作",
    excerpt: "因涉嫌慈善款去向不明，某一线女星正面临前所未有的公关危机，据传已有三个国际品牌暂停其代言合作。",
    content: "51爆料独家获悉，某一线女星创办的慈善基金会近三个月来的账目问题持续发酵，引发社会各界广泛关注。\n\n据知情人士透露，该基金会在过去一年内共募集善款超过8000万元，但仅有约2000万元有迹可循地用于慈善项目。剩余的6000万元去向成谜，基金会方面至今未能提供令人信服的解释。\n\n事件爆发后，该女星在社交媒体发布长文回应：「基金会的每一分钱都经过合法合规的程序，相关的审计报告将在近期公布。请大家给予时间和信任。」\n\n然而这份回应并未获得公众认可。多位法律人士指出，根据《慈善法》相关规定，基金会必须定期向社会公开财务信息，该女星的基金会显然存在违规嫌疑。\n\n截至目前，已有三个国际知名品牌确认暂停与该女星的代言合作，另有多家品牌正在观望中。据业内估算，如果所有代言合作终止，该女星将面临超过2亿元的违约金。\n\n市场监管部门已介入调查。51爆料将持续关注最新进展。",
    category: "mingxing-bagua",
    categoryName: "明星八卦",
    author: "51爆料调查组",
    authorAvatar: "",
    publishDate: "2026-07-02",
    readTime: "7分钟",
    viewCount: 445000,
    tags: ["明星", "慈善", "危机", "代言", "调查"],
    imageSeq: "article-5-hero",
    image: "https://readdy.ai/api/search-image?query=Chinese%20female%20celebrity%20charity%20gala%20event%20with%20red%20carpet%20and%20gold%20decorations%2C%20dramatic%20lighting%20with%20contrast%20shadows%2C%20editorial%20documentary%20style%2C%20tension%20atmosphere%2C%20warm%20crimson%20and%20dark%20tones&width=1600&height=900&seq=article-5-hero&orientation=landscape",
    relatedArticles: ["2", "3", "4"],
  },
  {
    id: "6",
    slug: "wanghong-fensi-zhanzheng-2026-07-01",
    title: "网红粉丝大战：两大顶流网红隔空互怼，双方粉丝评论区上演世纪骂战",
    excerpt: "两大人气网红因合作纠纷公开互撕，从直播间吵到社交平台，双方粉丝在评论区打得不可开交。",
    content: "一个价值千万的商务合作，引发了两大顶流网红之间的一场空前「战争」。\n\n事件起因于某国际奢侈品牌的中国区代言人争夺战。据业内人士透露，该品牌的年度代言费高达1200万元，吸引了多位头部网红的竞争。最终品牌方选择了拥有2800万粉丝的美妆博主「甜心酱」作为新一季代言人。\n\n落选的另一位拥有2500万粉丝的时尚博主「酷Girl」在随后的直播中含沙射影地表示：「有些人的数据，懂的都懂，品牌方被骗了都不知道。」\n\n这番言论迅速点燃了战火。甜心酱在社交平台发布长文，列举了自己过去一年的带货成绩，并暗示对方的「酷Girl品牌」涉嫌抄袭。\n\n至此，双方粉丝在各大平台展开了大规模「战争」。微博话题#甜心酱酷Girl互撕#阅读量突破15亿，评论区双方粉丝各据一方，场面极度混乱。\n\n品牌方最终发布声明：「感谢两位优秀创作者的关注，我们的选择基于专业的市场分析和品牌调性考量，请停止不实揣测。」\n\n这场风波也引发了关于网红行业生态的广泛讨论。无论如何，这场粉丝「大战」让两家粉丝活跃度飙升，有分析师笑称：「这可能是史上最贵的'营销'。」",
    category: "wanghong-dasai",
    categoryName: "网红每日大赛",
    author: "51爆料编辑部",
    authorAvatar: "",
    publishDate: "2026-07-01",
    readTime: "6分钟",
    viewCount: 678000,
    tags: ["网红", "粉丝大战", "代言", "互撕", "热度"],
    imageSeq: "article-6-hero",
    image: "https://readdy.ai/api/search-image?query=two%20Chinese%20internet%20influencers%20facing%20off%20in%20dramatic%20split%20composition%2C%20red%20and%20gold%20neon%20lighting%2C%20intense%20rivalry%20atmosphere%2C%20editorial%20fashion%20photography%20style%2C%20high%20contrast%20dramatic%20shadows%2C%20dark%20background%20with%20warm%20accents&width=1600&height=900&seq=article-6-hero&orientation=landscape",
    relatedArticles: ["1", "4", "5"],
  },
];

export const categories = [
  {
    slug: "wanghong-dasai",
    name: "网红每日大赛",
    description: "网红每日大赛实时追踪，全网反差不设防的吃瓜视频，所有八卦都在这里",
    icon: "ri-live-line",
    color: "primary",
    imageSeq: "cat-dasai",
  },
  {
    slug: "mingxing-bagua",
    name: "明星八卦",
    description: "明星八卦一手掌握，最新娱乐圈动态、明星恋情、独家爆料全收录",
    icon: "ri-star-line",
    color: "accent",
    imageSeq: "cat-bagua",
  },
  {
    slug: "heiliaozhuizong",
    name: "黑料追踪",
    description: "黑料追踪深度报道，曝光行业内幕，还原事实真相",
    icon: "ri-search-eye-line",
    color: "secondary",
    imageSeq: "cat-heiliao",
  },
  {
    slug: "chigua-shipin",
    name: "吃瓜视频",
    description: "吃瓜视频合集，全网最劲爆的反差视频、翻车现场一网打尽",
    icon: "ri-movie-line",
    color: "primary",
    imageSeq: "cat-chigua",
  },
];

export const comments = [
  {
    id: "c1",
    articleId: "1",
    user: "吃瓜不嫌事大",
    userTag: "资深吃瓜群众",
    content: "这就是为什么我从来不信网红的人设，滤镜一关，谁还不是个普通人？不过敢于素颜出镜，也算是勇气可嘉了。",
    likes: 3200,
    date: "2026-07-06",
  },
  {
    id: "c2",
    articleId: "1",
    user: "娱乐圈观察员",
    userTag: "娱乐博主",
    content: "说实话，小鹿酱的素颜也不算差，只是和平时差距太大。问题在于这个行业营造了太多不切实际的审美标准。",
    likes: 2800,
    date: "2026-07-06",
  },
  {
    id: "c3",
    articleId: "2",
    user: "八卦小能手",
    userTag: "娱乐资讯达人",
    content: "凌晨三点发声明，这公关团队估计一晚上没睡。说'目前单身'而不是'从未恋爱'，这个语言艺术，啧啧。",
    likes: 5100,
    date: "2026-07-05",
  },
  {
    id: "c4",
    articleId: "3",
    user: "消费维权先锋",
    userTag: "消费者权益志愿者",
    content: "直播间剧本这事早就不是什么秘密了，但这次被实锤还是有意义的。希望有关部门能好好查一查整个行业。",
    likes: 4600,
    date: "2026-07-04",
  },
];

export const testimonials = [
  {
    id: "t1",
    user: "吃瓜第一线",
    userTag: "51爆料忠实用户",
    content: "自从关注了51爆料，每天上班摸鱼都有新瓜吃。每日大赛板块是精华中的精华，逆天反差看到停不下来！",
    avatarSeq: "testimonial-1",
  },
  {
    id: "t2",
    user: "八卦雷达",
    userTag: "资深媒体人",
    content: "作为一个在娱乐圈混了十年的老人，51爆料的更新速度和独家深度让我刮目相看。很多料都是行业内部才能挖到的。",
    avatarSeq: "testimonial-2",
  },
  {
    id: "t3",
    user: "追瓜少女",
    userTag: "大学生",
    content: "宿舍姐妹每天起床第一件事就是打开51爆料看今日大赛排名，比追剧还上头！强烈推荐吃瓜视频频道，反差视频笑到头掉。",
    avatarSeq: "testimonial-3",
  },
];